import { createReduxEnhancer } from '@sentry/react';
import { StoreEnhancer } from 'redux';

export const createSentryEnhancer = (): StoreEnhancer => {
    const sentryEnhancer = createReduxEnhancer({
        // -ignore
        stateTransformer: (state) => {
        // Transform the state to remove sensitive information
            const transformedState = {
                ...state,
                Appointment: {
                // ...state.Appointment,
                    ApptCust: {
                    // ...state.Appointment.ApptCust,
                        custFirstName: '*****',
                        custLastName: '*****',
                        custEmailAddress: '*****',
                        custPhoneNumber: '*****',
                    },
                },
                Customer: {
                    firstName: '****',
                    lastName: '****',
                    emailAddress: '****',
                    phoneNumber: '****',
                    streetAddress: '****',
                    city: '****',
                    stateAddress: '****',
                    zipCode: '****',
                },
            };

            return transformedState;
        },
        actionTransformer: (action) => {
            const tempAction: { type: string, payload: any } = { type: '', payload: ''};
            switch (action.type) {
                case 'Appointment/UPDATE_CUST':
                case 'Customer/CREATE_ACCT':
                case 'Customer/UPDATE_CUSTOMER':
                case 'Customer/CUSTOMER_SEARCH':
                case 'Customer/LOGIN_CUSTOMER':
                case 'Customer/RESET_PASSWORD':
                case 'Customer/CHECK_PHONE_OPT_IN':
                    tempAction.type = action.type;
                    tempAction.payload = 'Customer data updated';

                    return tempAction;

                default:
                    return action;
            }
        },
    });

    return sentryEnhancer as StoreEnhancer;
};